import {
  ChangeDetectorRef,
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewChild,
} from '@angular/core';
import { BaseListComponent } from '../../../../../../components/base-list.component';
import { BsModalService } from 'ngx-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { TicketService } from '../../../../../../common/services/Ticket.service';
import { ContactService } from '../../../../../../common/services/Contact.service';
import { UserService } from '../../../../../../common/services/User.service';
import { SearchService } from '../../../../../../common/services/Search.service';
import { ContactsConst } from './contacts.const';
import * as _ from 'lodash';
import { FormFieldType, ModalType } from '../../../../../../components/modals/modal-form-template/modal-form.const';

@Component({
  selector: 'detail-organize-contacts',
  templateUrl: './contacts.component.html',
  styleUrls: ['./contacts.component.css', '../../../../../../../css/fuck.css', '../../../search/search.css'],
  providers: [TicketService, ContactService, UserService, SearchService],
})
export class ContactsComponent extends BaseListComponent {
  @ViewChild('modalTemplate') modalTemplate: ElementRef;

  @Input() organize_id: any = null;
  @Output() onOpenUser: EventEmitter<any> = new EventEmitter();

  public modelFilter: any = {
    source: '',
  };
  public allSources = [
    { id: '', text: 'Nguồn khởi tạo' },
    { id: 'CALL_OUTBOUND', text: 'Gọi điện ra' },
    { id: 'CALL_INBOUND', text: 'Khách gọi điện' },
    { id: 'chat', text: 'Tin nhắn web' },
    { id: 'hand', text: 'Thêm mới' },
    { id: 'zalo', text: 'Zalo' },
    { id: 'email', text: 'Email' },
    { id: 'facebook', text: 'Kênh Facebook' },
  ];
  constructor(
    protected changeDetector: ChangeDetectorRef,
    protected modalService: BsModalService,
    protected toastr: ToastrService,
    private searchService: SearchService,
    private contactService: ContactService
  ) {
    super(changeDetector, toastr, modalService);
    this.displayColumns = ContactsConst.displayColumns();
  }

  async ngOnInit() {
    await this.loadData();
  }

  async loadData(request: any = {}, sort: any = {}) {
    const must: any = [{ term: { organize_id: this.organize_id } }];
    if (this.modelFilter.source) {
      must.push({ match: { source: this.modelFilter.source } });
    }

    const condition = {
      must: must,
    };
    const body = {
      condition: JSON.stringify(condition),
      active_fields: JSON.stringify(['organize_id']),
      type: 'user',
      label: 'and',
      sub_label: 'and',
      keyword: '',
      force_search: 'customer',
    };
    request = _.merge({}, body, request);

    const payload = await this.buildBasePayload(request, sort);
    this.searchService.all(payload).subscribe(res => {
      if (res.status == 200 && !res.error) {
        this.data = res.data.list;
        this.data = this.data.map(e => {
          e.display_name = ContactsConst.displayNameColumns(e, this.user);
          e.display_phone = ContactsConst.displayPhoneColumns(e, this.user);
          e.display_email = ContactsConst.displayEmailColumns(e);
          e.display_organize = ContactsConst.displayOrganizeColumns(e);
          e.display_group = ContactsConst.displayGroupColumns(e);
          e.display_city = ContactsConst.displayCityColumns(e);
          e.display_source = ContactsConst.displaySourceColumns(e);
          e.display_created_at = ContactsConst.displayTimeColumns(e.created_at);
          return e;
        });
        this.initPage(res.data.total);
      } else {
        this.data = [];
      }
    });
  }
  async changeFilter(key, $event) {
    let value = $event.target.value;
    if (value === '-1') {
      value = '';
    }
    this.modelFilter[key] = value;
    await this.loadData();
  }
  async resetModelFilter() {
    this.modelFilter = {
      source: '',
    };
    await this.loadData();
  }
  async submitMergeContact(id) {
    const mergeContacts = this.lstChecked.filter(contact => contact !== id);
    this.contactService.merges({ user_id: id, merge_user_ids: mergeContacts }).subscribe(res => {
      if (res.status == 200 && !res.error) {
        this.throwSuccess('Hợp nhất ticket thành công!');
        this.closeModal();
        this.is_loading = true;
        setTimeout(() => {
          this.loadData();
          this.is_loading = false;
        }, 3000);
      } else {
        this.message = {
          class: 'alert dark alert-danger',
          content: res.message,
        };
      }
    });
  }
  async openMergeContacts() {
    this.typeModal = 'mergeContacts';
    let contactToMerge =
      this.data
        .filter(data => this.lstChecked.includes(data._id))
        .map(data => {
          return { id: data._id, text: data.name };
        }) || [];
    const config = {
      backdrop: true,
      ignoreBackdropClick: true,
      class: 'modal-md',
      keyboard: false,
    };
    this.modelContent = {
      type: ModalType.Primary,
      title: 'Hợp nhất nhanh khách hàng',
      submit_title: 'Hợp nhất',
    };
    this.modelDisplay = [
      {
        key: 'main_id',
        label: 'Chọn khách hàng chính',
        type: FormFieldType.Select2,
        value: this.model.main_id,
        required: true,
        disabled: false,
        width: 'full',
        order: 0,
        options: {
          data: [{ id: '', text: 'Chọn' }, ...contactToMerge],
          select2Options: {
            placeholder: { id: '', text: 'Khách hàng chính' },
          },
        },
      },
      {
        key: '_note',
        label: '',
        type: FormFieldType.Note,
        value: `<span class="mb-2 text-muted text-sm mt-1">Vui lòng chọn khách hàng chính trong danh sách khách hàng bạn đã chọn. Tất cả các khách hàng khác sẽ được hợp nhất vào khách hàng này!</span>`,
        width: 'full',
        order: 1,
      },
    ];
    this.openModal(this.modalTemplate, config);
  }

  async handleSubmit(item?: any) {
    await this.submitMergeContact(item.main_id);
  }
  async openUser(user: any) {
    this.onOpenUser.emit({ data: user });
  }
}



// WEBPACK FOOTER //
// ./src/app/pages/admin/icontact/tabs/organize/contacts/contacts.component.ts